import { isDefined } from "@clipboard-health/util-ts";

import { type RedeemReferralCodeResponse } from "./api/useRedeemReferralCode";

interface ErrorDisplay {
  title: string;
  message: string;
}

export function isReferralRedeemSuccess(redeemResult: RedeemReferralCodeResponse | undefined) {
  if (!isDefined(redeemResult)) {
    return false;
  }

  const { referralCodeValid, bonusAmount } = redeemResult;
  return referralCodeValid && isDefined(bonusAmount) && bonusAmount > 0;
}

export function getErrorMessageFromRedeemResult(
  redeemResult: RedeemReferralCodeResponse | undefined
): ErrorDisplay {
  if (!isDefined(redeemResult)) {
    return { title: "Unexpected error", message: "Please try again later." };
  }

  const { message, resultType } = redeemResult;

  if (resultType === "failure_own_code") {
    return {
      title:
        "You cannot use your own referral link. However, you can still earn a bonus by referring your friends!",
      message: "",
    };
  }

  if (resultType === "failure_already_worked") {
    return {
      title: "You are ineligible for this referral because you've already worked your first shift",
      message: "You can share your referral link with your friends and earn a bonus that way!",
    };
  }

  return { title: "Could not redeem referral", message };
}
